<template>
    <div class="studentConfig clearfix">
        <div class="left">
            <div class="title">
                <!-- <span class="el-icon-refresh" style="margin-left:79px;cursor:pointer;" @click="synStuInfo" v-if="user.style !== K12TYPE">更新学生信息</span> -->
                <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对学生的管理，本页只保留查询和导出 -->
                <span class="el-icon-refresh" style="float:right;margin-top:12px;cursor:pointer;" @click="xfStuInfo" v-if="kqDeviceCode === 1">下发学生信息</span>
                部门组织
            </div>
            <div class="box">
                <div class="tree-box">
                    <el-tree :data="schoolOrganization" node-key="id" @node-click="loadTableDataByTree" :expand-on-click-node="false" :props="deptProps" ref="schoolTree" highlight-current>
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span class="label-text" :class="{'icon-college': data.type == 2 || data.type == 6, 'icon-department': data.type == 3, 'icon-grade': data.type == 4, 'icon-class': data.type == 5}">{{node.label}}</span>
                        </span>
                    </el-tree>
                </div>

            </div>
        </div>
        <div class="right">
            <div class="operation-panel">
                <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对学生的管理，本页只保留查询和导出 -->

                <!-- <span class="btn delete-icon" @click="comfrimDeleteStudent()" v-if="user.style !== K12TYPE">
                    全部删除
                </span>
                <span class="btn add-icon" @click="addStudent" v-if="user.style !== K12TYPE">
                    添加
                </span>
                <span v-if="user.style !== K12TYPE" class="btn import" @click="showImport = true;importObj={
                    title: '导入学生',
                    text: '点击下载学生导入模板',
                    url: '/static/学生导入模板.xlsx',
                    key: 'studentFile',
                    api: 'importStudent'
                }">
                    导入学生
                </span>
                <span class="btn import" @click="openBatchStuImgImport">
                    导入照片
                </span> -->
                <span class="btn export" @click="openExportDialog">
                    导出
                </span>
                <el-input class="input" placeholder="请输入学生姓名查询" v-model="studentName">
                    <el-button slot="append" icon="el-icon-search" @click="queryStudentByName">查询</el-button>
                </el-input>
            </div>
            <div class="tableList">
                <el-table border stripe :data="dataList" @selection-change="selectHandle" header-row-class-name="table-header" style="width: 1200px;">
                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" align="center">
                        <span class="studentname" slot-scope="scope" @click="studentInfoDialog(scope.row, $event)">{{scope.row.name}}</span>
                    </el-table-column>
                    <el-table-column prop="schoolStudentNo" label="学号" align="center">
                    </el-table-column>
                    <el-table-column prop="parentDepartmentName" label="学院" width="110" align="center" v-if="user.style !== K12TYPE">
                    </el-table-column>
                    <el-table-column prop="departmentName" label="系部" width="110" align="center" v-if="user.style !== K12TYPE">
                    </el-table-column>
                    <el-table-column prop="gradeName" label="年级" align="center">
                    </el-table-column>
                    <el-table-column prop="className" label="班级" align="center">
                    </el-table-column>
                    <el-table-column prop="phone" label="联系电话" align="center">
                    </el-table-column>
                    <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对学生的管理，本页只保留查询和导出 -->
                    <!-- <el-table-column prop="id" label="操作" align="center" v-if="user.style !== K12TYPE">
                        <template slot-scope="scope">
                            <span class="operate" @click="editStudent(scope.row)">编辑</span>
                            <span class="operate" @click="comfrimDeleteStudent(scope.row.id)">删除</span>
                        </template>
                    </el-table-column> -->
                    <!-- 2020-06-16 新增单个学生下发 -->
                    <!-- v-if="kqDeviceCode === 1" -->
                     <el-table-column   prop="phone" label="下发学生基础信息" align="center">
                         <template slot-scope="scope">
                            <span class="operate"  @click="singleSendData(scope.row)">下发</span>
                            <span class="operate" @click="delHKStuData(scope.row)">删除</span>
                         </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container ">
                    <v-pagination :isShow="showPagination" @pageChange="onCurrentChange" :total="total" :page="page"></v-pagination>
                </div>
            </div>
        </div>
        <!-- 导入 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="importObj.title" :visible.sync="showImport" width="500px" left :before-close="cancelImportDialog">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span> 建议一次导入不超过1000条数据
            </div>
            <div class="import-dialog">
                <p class="red">{{importErrorMsg}}</p>
                <div>
                    <el-input readonly class="input-text" v-model="importFileName"></el-input>
                    <div class="rel-import-btn">
                        选择文件
                        <input ref="importFile" class="import-btn" type="file" @change="changeExl" />
                    </div>

                </div>
                <div class="down-tepmlate">
                    <i></i>
                    <a :href="importObj.url" :download="importObj.title + '模板.xlsx'">{{importObj.text}}</a>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="uploadFile">确定</el-button>
                <el-button @click="cancelImportDialog">取消</el-button>
            </span>
        </el-dialog>
        <!-- 新增学生 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="editType === 0 ? '添加学生' : '编辑学生资料'" :visible.sync="showStudentInfoForm" width="790px" class="addStuForm" left :before-close="closeDialog">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span> 带
                <span class="red">*</span>号的为必填项
            </div>
            <div class="info">
                <div class="avatar-wrapper">
                    <div class="img">
                        <img v-show="studentInfoForm.relPicPath || studentInfoForm.picPath" :src="studentInfoForm.relPicPath">
                    </div>
                    <uploadfile @upload="acceptFile" buttonname="上传照片" acceptType=".jpg,.jpeg" maxSizeMsg='照片大小超过200KB，请重新上传！' :maxFileSize="204800"></uploadfile>
                </div>
                <el-form ref="studentInfoForm" :model="studentInfoForm">
                    <ul class="form">
                        <li>
                            <el-form-item prop="studentName" :rules="[{required: true,trigger:'blur',message:'请输入学生姓名'},vRules.illegalCharacter]">
                                <p class="label">
                                    <span class="red">*</span>姓名：</p>
                                <el-input v-model="studentInfoForm.studentName" type="text" maxlength="20" placeholder="限20字符以内，非特殊字符" v-inputexclude="'\\s+'">
                                </el-input>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="sex" :rules="[{required: true,trigger:'blur',message:'请选择性别'}]">
                                <p class="label">
                                    <span class="red">*</span>性别：</p>
                                <el-select v-model="studentInfoForm.sex" placeholder="--请选择性别--">
                                    <el-option v-for="item in gender" :key="item.value" :label="item.label" :value="item.value">{{item.label}}</el-option>
                                </el-select>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="schoolStuNo" :rules="[{required: true,trigger:'blur',message:'请输入学号'},vRules.numberPattern]">
                                <p class="label">
                                    <span class="red">*</span>学号:</p>
                                <el-input v-model="studentInfoForm.schoolStuNo" type="text" maxlength="20" placeholder="限数字，20字以内" v-inputexclude="'\\s+'">
                                </el-input>
                            </el-form-item>

                        </li>
                        <li>
                            <el-form-item prop="className" ref="formItemClassname" :rules="[{required: true,trigger:'blur',message:'请选择班级'}]">
                                <p class="label">
                                    <span class="red">*</span>班级:</p>
                                <el-input v-model="studentInfoForm.className" readonly placeholder="请选择班级" @click.native="deptValueShow = !deptValueShow" suffix-icon="el-icon-arrow-down"></el-input>
                                <el-tree y :default-expanded-keys="[this.studentInfoForm.classTreeId]" highlight-current ref="treeToSelectClass" node-key="id" v-show="deptValueShow" :data="schoolOrganizationForClassSelect" :props="deptProps" :expand-on-click-node="false" @node-click="deptTreeNodeHandleClick" class="combotree class-tree-hook">
                                </el-tree>
                            </el-form-item>

                        </li>
                        <li>
                            <el-form-item prop="birthDate">
                                <p class="label">出生日期：</p>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="studentInfoForm.birthDate" type="date" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="joinDate">
                                <p class="label">入学日期：</p>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="studentInfoForm.joinDate" type="date" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="mobile" :rules="[vRules.numberPattern,vRules.mobilePhone]">
                                <p class="label">联系电话：</p>
                                <el-input v-model="studentInfoForm.mobile" type="text" maxlength="20" placeholder="限数字，20字以内" v-inputexclude="'\\s+'">
                                </el-input>
                            </el-form-item>

                        </li>
                        <li>
                            <el-form-item prop="inHouseDate">
                                <p class="label">入宿日期：</p>
                                <el-date-picker disabled value-format="yyyy-MM-dd" v-model="studentInfoForm.inHouseDate" type="date" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="nation" :rules="[vRules.illegalCharacter]">
                                <p class="label">民族</p>
                                <el-input v-model="studentInfoForm.nation" type="text" maxlength="20" placeholder="限20字符以内，非特殊字符" v-inputexclude="'\\s+'">
                                </el-input>
                            </el-form-item>
                        </li>
                        <li>
                            <el-form-item prop="remarks" :rules="[vRules.illegalCharacter]">
                                <p class="label">备注</p>
                                <el-input v-model="studentInfoForm.remarks" type="text" maxlength="20" placeholder="限20字符以内，非特殊字符" v-inputexclude="'\\s+'">
                                </el-input>
                            </el-form-item>
                        </li>
                    </ul>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmStudentInfoForm">确定</el-button>
                <el-button @click="cancelFormEdit('showStudentInfoForm','studentInfoForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 批量导入照片 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="importObj.title" :visible.sync="showBatchStudentImgImport" width="780px" height="586px" left>
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span> Zip文件，200M以内!
                <span class="red">*</span>
            </div>
            <div class="import-student-pic">
                <p class="red">{{importErrorMsg}}</p>
                <div>
                    <el-input readonly class="input-text" v-model="importFileName"></el-input>
                    <uploadfile ref="imgzipupload" :showTips="false" @upload="acceptZipFile" buttonname="选择文件" acceptType=".zip" :maxFileSize="209715200" max-size-msg="导入文件大小超过了200M，请核查后再试！"></uploadfile>

                </div>
                <div class="img-demand">
                    <div class="title">照片要求</div>
                    <div class="box">
                        <div class="img-box">
                            <div class="img-ex"></div>
                            0.0001_1.jpg
                        </div>
                        <div class="demand-box">
                            <p class="line">尺寸要求640*480，大小不能超过200kb</p>
                            <p class="line">仅支持jpg、jpeg格式</p>
                            <p class="line">以学号命名照片，如示例0001</p>
                        </div>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="default" @click="uploadZipFile">确定</el-button>
                <el-button @click="canelzipimgDialog">取消</el-button>
            </span>
        </el-dialog>
        <!-- 查看学生详情 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="学生资料" :visible.sync="showStudentInfoDetail" width="790px" class="stu-detail" left>
            <div class="edit el-icon-edit" @click="stuDetailToEdit" v-if="user.style !== K12TYPE"></div>
            <div class="info">
                <div class="avatar-wrapper">
                    <div class="img">
                        <img v-show="studentInfoForm.relPicPath || studentInfoForm.picPath" :src="studentInfoForm.relPicPath">
                    </div>
                </div>
                <el-form ref="studentInfoForm" :model="studentInfoForm">
                    <ul class="detail">
                        <li>
                            <p class="label">姓名：</p>
                            <p class="text">{{studentInfoForm.studentName}}</p>
                        </li>
                        <li>
                            <p class="label">性别：</p>
                            <p class="text">{{studentInfoForm.sex == 1 ? '男' : '女'}}</p>

                        </li>
                        <li>
                            <p class="label">学号</p>
                            <p class="text">{{studentInfoForm.schoolStuNo}}</p>

                        </li>
                        <li>
                            <p class="label">班级</p>
                            <p class="text">{{studentInfoForm.className}}</p>
                        </li>
                        <li>
                            <p class="label">出生日期：</p>
                            <p class="text">{{studentInfoForm.birthDate}}</p>
                        </li>
                        <li>
                            <p class="label">入学日期：</p>
                            <p class="text">{{studentInfoForm.joinDate}}</p>

                        </li>
                        <li>
                            <p class="label">联系电话：</p>
                            <p class="text">{{studentInfoForm.mobile}}</p>

                        </li>
                        <li>
                            <p class="label">入宿日期：</p>
                            <p class="text">{{studentInfoForm.inHouseDate}}</p>
                        </li>
                        <li>
                            <p class="label">民族</p>
                            <p class="text">{{studentInfoForm.nation}}</p>

                        </li>
                        <li>
                            <p class="label">备注</p>
                            <p class="text">{{studentInfoForm.remarks}}</p>
                        </li>
                    </ul>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showImportSuccess" width="400px" left :title="importObj.title" :before-close="closeERRDialog">
            <div style="height:158px;padding:30px 50px;text-align: center">
                <div style="margin-bottom:20px;">
                    <span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span>
                </div>
                <p>导入成功
                    <span class="red">{{importObj.stotal}}</span>条;失败
                    <span class="red">{{importObj.etotal}}条</span>!</p>
                <div v-show="importObj.etotal > 0" class="down-tepmlate" style="padding-top:0;">
                    <i></i>
                    <a @click="downErrExl(importObj.errpath)">点击下载失败名单列表</a>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmDialog">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import basetable from '@/mixins/base-table'
import api from '@/api'
import vRules from '@/config/validate_rules'
import { session } from '@/util'
import uploadfile from '@/components/upload_img/uploadfile.vue'
import { mapState } from 'vuex';

export default {
    components: {
        uploadfile
    },
    mixins: [basetable],
    props: {
        kqDeviceCode: null
    },
    data () {
        let user = session('user');
        return {
            vRules,
            user,
            editType: 0,
            showBatchStudentImgImport: false,
            studentImportFileName: '',
            importStudentErrorMsg: '',
            showBatchStudentImport: false,
            studentName: '',
            formData: {
                stuName: '',
                schoolId: user.schoolId,
                schoolNum: '',
                collegeId: '',
                departId: '',
                gradeId: '',
                classId: ''
            },
            classCombobox: [{
                label: '一年级',
                value: '01'
            }, {
                label: '二年级',
                value: '02'
            }, {
                label: '三年级',
                value: '03'
            }],
            studentInfoForm: {
                studentName: '',
                picPath: '',
                relPicPath: '',
                nation: '',
                schoolStuNo: '',
                classId: '',
                classTreeId: '',
                className: '',
                sex: '',
                mobile: '',
                birthDate: '',
                inHouseDate: '',
                joinDate: '',
                remarks: '',
                userId: '',
                departName: '',
                departmentId: '',
                gradeId: '',
                gradeName: '',
                schoolNum: '',
                schoolId: '',
                userId: user.accountId,
                style: user.style
            },
            showStudentInfoDetail: false,
            deptValueShow: false,
            showStudentInfoForm: false,
            studentDialogTitle: '添加学生',
            selection: [],
            studentName: '',
            // 最终的树数据
            deptProps: {
                label: 'directorName',
                children: 'nextLevels',
                isLeaf: 'leaf'
            },
            schoolOrganization: null,
            schoolOrganizationForClassSelect: null,
            // 导入
            importObj: {
                title: '导入学生',
                text: '点击下载学生导入模板',
                url: '/static/导入学生模板.xlxs',
                key: 'studentFile',
                api: 'importStudent',
                stotal: '',
                etotal: '',
                errpath: ''
            },
            showImportSuccess: false,
            showImport: false,
            importErrorMsg: '',
            FileList: [], // 头像上传
            zipFileList: [], // 图片压缩包上传
            File: null, // 最终上传的formdata
            importFileName: '',
            fileName: '',
            // 下拉
            gender: [{ label: '男', value: '1' }, { label: '女', value: '2' }],
            defaultExpandedKeys: [],
            currentDeptNode: null,
            lunxunrequesttimer: null,

        }
    },
    watch: {
        // 上传 头像
        FileList (files) {
            if (files.length > 0) {
                var formData = new FormData();
                formData.append('file', files[0]);
                this.File = formData;
                api.systemConfig.uploadFile(this.File)
                    .then((res) => {
                        if (res.code == 0) {
                            this.studentInfoForm.picPath = res.data;
                            this.studentInfoForm.relPicPath = `/suguan/oss/i/${res.data}?token=${res.token}`;
                        } else {
                            this.$message(res.message);
                        }
                    })
            }
        },
        // 导入照片ZIP
        zipFileList (files) {
            if (files && files.length > 0) {
                this.importFileName = files[0].name;
            } else {
                this.importFileName = '';
                this.importErrorMsg = '';
            }
        }
    },
    computed: {
        ...mapState([
            'K12TYPE',
            'UNK12TYPE'
        ])
    },
    methods: {
        delHKStuData(row) {
              let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认删除该学生在海康的信息吗？</p>
                        </div>`;

            this.$alert(html, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: true
            }).then(() => { 
                  let {
                    id:studentId,
                    schoolId,
                    studentType
                } = row;
                api.systemConfig.singleDelHKStuInfo({
                    studentId,
                    studentType,
                    schoolId,
                }).then(res => {
                
                    if(res.code === 0){
                    
                        this.showTip('删除成功')
                    }else{
                        this.showTip(res.message,"error")
                    }
                })
            })
        },
        singleSendData(row) {
            let {
              id:stuId,
                name:stuName,
                image:img,
                sex,
                schoolId,
                        studentType
            } = row;
            api.systemConfig.singleSendData({
                stuId,
                stuName,
                img,
                sex,
                schoolId,
                studentType

            }).then(res => {
                console.log(res)
                if(res.code === 0){
                    this.showTip('下发成功')
                }else{
                    this.showTip(res.message,"error")
                }
            })
        },
        closeERRDialog (done) {
            this.loadDataByParam(this.currentDeptNode, '');
            done();
        },
        comfirmDialog () {
            this.loadDataByParam(this.currentDeptNode, '');
            this.showImportSuccess = false;
        },
        // 加载表格数据
        loadData () {
            Object.assign(this.formData, {
                pageNum: this.page,
                pageSize: this.size
            })
            api.systemConfig.queryUnK12StuList(this.formData).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    this.dataList = data.list;
                }

            })
        },
        loadDataInFirstPage () {
            this.page < 2 ? this.loadData() : this.page = 1;
            // this.loadData();
        },
        handleImportStudentExlSuccess (res) {
            let html = `<div class="deleteComfirl1" ref="deleteComfirl1" style="width:380px;height:158px;padding:0 50px;text-align: center">
                            <div style="margin-bottom: 20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>导入成功 <span class="red">121</span>条;失败<span class="red">9</span>条</p>
                            <p class="err-template"><i></i><a>点击下载失败名称列表</a></p>
                        </div>`;

            let layerID = this.$layer.confirm(html, {
                title: '导入学生',
                btn: ['确定']
            }, () => {
                this.$layer.close(layerID);
            });
        },
        beforeImportStudentExlUpload (file) {
            let reg = /\.xlxs$/;
            if (reg.test(file.name)) {
                return true;
            }
            this.$message.error('只能上传excel文件!');
            return false;
        },
        // 添加编辑学生
        addStudent () {
            this.querySchoolTreeForClassSelect();
            this.editType = 0;
            this.showStudentInfoForm = true;
            this.deptValueShow = false;
            this.$nextTick(() => {
                this.studentInfoForm = {
                    studentName: '',
                    picPath: '',
                    relPicPath: '',
                    nation: '',
                    schoolStuNo: '',
                    classId: '',
                    className: '',
                    sex: '',
                    mobile: '',
                    birthDate: '',
                    inHouseDate: '',
                    joinDate: '',
                    remarks: '',
                    userId: '',
                    departName: '',
                    departmentId: '',
                    gradeId: '',
                    gradeName: '',
                    schoolNum: '',
                    schoolId: '',
                    userId: this.user.accountId,
                    style: this.user.style
                }
            })
        },
        editStudent (row) {
            this.editType = 1;
            this.showStudentInfoForm = true;
            this.deptValueShow = false;
            // 查询班级
            this.querySchoolTreeForClassSelect().then(() => {
                this.$refs.treeToSelectClass.setCurrentKey(row.treeId);
                this.studentInfoForm.classTreeId = row.treeId;
            })
            this.$nextTick(() => {
                this.studentInfoForm.studentName = row.name;
                this.studentInfoForm.birthDate = row.birthday ? row.birthday.substring(0, 10) : '';
                this.studentInfoForm.joinDate = row.joinSchYearMonth ? row.joinSchYearMonth.substring(0, 10) : '';
                this.studentInfoForm.schoolStuNo = row.schoolStudentNo;
                this.studentInfoForm.mobile = row.phone;
                this.studentInfoForm.remarks = row.remark;
                this.studentInfoForm.departName = row.departmentName;
                this.studentInfoForm.picPath = row.image;
                this.studentInfoForm.relPicPath = row.image ? '/suguan/oss/i/' + row.image + '?token=' + session('token').accesstoken : '';
                Object.assign(this.studentInfoForm, row);
                this.studentInfoForm.inHouseDate = row.inHouseDate ? row.inHouseDate.substring(0, 10) : '';

            })
        },
        comfirmStudentInfoForm: function () {
            this.$refs.studentInfoForm.validate((valid) => {
                if (valid) {
                    let url = this.editType === 0 ? 'addUnK12StuInfo' : 'updUnK12StuInfo';
                    api.systemConfig[url](this.studentInfoForm).then((res) => {
                        if (res.code == 0) {
                            this.cancelFormEdit('showStudentInfoForm', 'studentInfoForm');
                            this.loadData();
                        } else {
                            this.$message(res.message);
                        }
                    })
                }
            })

        },
        studentInfoDialog (row) {
            this.showStudentInfoDetail = true;
            this.studentInfoForm.studentName = row.name;
            this.studentInfoForm.birthDate = row.birthday ? row.birthday.substring(0, 10) : '';
            this.studentInfoForm.joinDate = row.joinSchYearMonth ? row.joinSchYearMonth.substring(0, 10) : '';
            this.studentInfoForm.schoolStuNo = row.schoolStudentNo;
            this.studentInfoForm.mobile = row.phone;
            this.studentInfoForm.remarks = row.remark;
            this.studentInfoForm.departName = row.departmentName;
            this.studentInfoForm.picPath = row.image;
            this.studentInfoForm.relPicPath = row.image ? '/suguan/oss/i/' + row.image + '?token=' + session('token').accesstoken : '';
            Object.assign(this.studentInfoForm, row);
            this.studentInfoForm.inHouseDate = row.inHouseDate ? row.inHouseDate.substring(0, 10) : '';

        },
        stuDetailToEdit () {
            this.showStudentInfoDetail = false;
            this.showStudentInfoForm = true;
            this.editType = 1;
        },
        cancelFormEdit (dialog, form) {
            this[dialog] = false;
            this.$refs[form].resetFields();
            this.deptValueShow = false;
            this.studentInfoForm = {
                studentName: '',
                picPath: '',
                relPicPath: '',
                nation: '',
                schoolStuNo: '',
                classId: '',
                className: '',
                sex: '',
                mobile: '',
                birthDate: '',
                inHouseDate: '',
                joinDate: '',
                remarks: '',
                userId: '',
                departName: '',
                departmentId: '',
                gradeId: '',
                gradeName: '',
                schoolNum: '',
                schoolId: '',
                userId: this.user.accountId
            }
        },
        selectHandle (s) {
            // 删除列表
            this.selection = s;
        },
        loadDataByParam (data, stuName) {
            this.formData = {
                stuName: stuName,
                schoolId: this.user.schoolId,
                schoolNum: '',
                collegeId: '',
                departId: '',
                gradeId: '',
                classId: ''
            };
            // 点的是院校
            if (data.type == 2) {
                this.formData.collegeId = data.relId;
            }
            // 点的是系
            if (data.type == 3) {
                this.formData.departId = data.relId;
            }
            // 点的是年级
            if (data.type == 4) {
                this.formData.gradeId = data.relId;
                if(this.$refs.schoolTree.getNode(data.parentId).data.type == 6) {
                     this.formData.schoolNum = this.$refs.schoolTree.getNode(data.parentId).data.relId;
                }
            }
            // 点的是班级
            if (data.type == 5) {
                this.formData.classId = data.relId;
            }
            // 点的是校区
            if (data.type == 6) {
                this.formData.schoolNum = data.relId;
            }
            this.loadDataInFirstPage();
        },
        loadTableDataByTree (data, node, c) {
            this.studentName = ''
            this.currentDeptNode = data;
            this.loadDataByParam(this.currentDeptNode);

        },
        deptTreeNodeHandleClick (data, node) {
            // 点的是班级才可以选择
            if (data.type == 5) {
                Object.assign(this.studentInfoForm, {
                    classId: data.relId,
                    className: data.directorName,
                    departmentId: data.grandId,
                    departName: data.grandName,
                    gradeId: data.parentId,
                    gradeName: data.parentName,
                    schoolNum: data.schoolNum,
                    schoolId: data.schoolId
                })
                this.$refs.formItemClassname.clearValidate();
                this.deptValueShow = false;
            }
        },
        queryStudentByName () {
            let data = this.$refs.schoolTree.getCurrentNode();
            this.formData.stuName = this.studentName;
            // 点的是院校
            if (data.type == 2) {
                this.formData.collegeId = data.relId;
            }
            // 点的是系
            if (data.type == 3) {
                this.formData.departId = data.relId;
            }
            // 点的是年级
            if (data.type == 4) {
                this.formData.gradeId = data.relId;
                if(this.$refs.schoolTree.getNode(data.parentId).data.type == 6) {
                     this.formData.schoolNum = this.$refs.schoolTree.getNode(data.parentId).data.relId;
                }
            }
            // 点的是班级
            if (data.type == 5) {
                this.formData.classId = data.relId;
            }
            this.loadDataInFirstPage();
        },
        closeDialog (done) {
            this.$refs.studentInfoForm && this.$refs.studentInfoForm.resetFields();

            done();
        },
        openSuccessDialog (title, msg) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>${msg}!</p>
                        </div>`;

            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => { })
        },
        comfrimDeleteStudent (id = '') {
            let param = {
                userId: this.user.accountId,
                schoolId: this.user.schoolId
            }
            let url, html;
            if (!id) {
                let data = this.currentDeptNode;
                if (data) {
                    // if (data.type == 1) {
                    //     param.schoolId = data.relId;
                    // }
                    // 点的是院校
                    if (data.type == 2) {
                        param.collegeId = data.relId;
                    }
                    // 点的是系
                    if (data.type == 3) {
                        param.departId = data.relId;
                    }
                    // 点的是年级
                    if (data.type == 4) {
                        param.gradeId = data.relId;
                    }
                    // 点的是班级
                    if (data.type == 5) {
                        param.classId = data.relId;
                    }
                } else {
                    this.$message('请先选择部门组织！');
                }
                url = 'batchDeleteStu';
                html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认删除吗？</p>
                            <p>删除后学生所有数据也会一起删除！</p>
                        </div>`;

            } else {
                param.id = id;
                url = 'deleteUnK12StuInfo';
                html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认删除该学生吗?</p>
                            <p>该学生所有数据也会一起删除！</p>
                        </div>`;

            }


            this.$alert(html, '确认删除？', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定删除',
                showCancelButton: true
            }).then(() => {

                let successfunction = (res) => {
                    if (res.code == 0) {
                        if (id) {
                            this.openSuccessDialog('删除成功', '删除成功');
                            this.loadData();
                        } else { // 批量
                            const loading = this.$loading({
                                lock: true,
                                text: '正在批量删除，请稍候...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            })
                            let lunxunrequest = () => {

                                return api.systemConfig.checkDeleteStatus().then((res) => {
                                    if (res.code == 0 && res.data) {
                                        loading.close();
                                        this.openSuccessDialog('删除成功', '删除成功');
                                        this.loadData();

                                    } else {
                                        this.lunxunrequesttimer = setTimeout(() => {
                                            lunxunrequest();
                                        }, 2000)
                                    }
                                }).catch(() => {
                                    this.lunxunrequesttimer = null;
                                    loading.close();
                                    this.$message('删除学生信息失败!');
                                })
                            }
                            lunxunrequest();
                        }

                    } else {
                        this.$message(res.message);
                    }
                }

                api.systemConfig[url](param).then((res) => {
                    successfunction(res);
                })
            }).catch(() => { })
        },
        // 导出
        openExportDialog () {
            let html = `<div class="deleteComfirl1" ref="deleteComfirl1" style="width:400px;padding:20px 50px;text-align: center">
                            <div style=""><span class="el-icon-question" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认将选中学生信息导出到本地？</p>
                        </div>`;

            this.$alert(html, '导出学生', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定导出',
                showCancelButton: true
            }).then(() => {
                this.exportStu();
            })
        },
        exportStu () {
            let data = this.$refs.schoolTree.getCurrentNode();
            if (data) {
                var param = {
                    stuName: this.studentName,
                };
                // 点的是学校
                if (data.type == 1) {
                    param.schoolId = data.relId;
                }
                // 点的是院校
                if (data.type == 2) {
                    param.collegeId = data.relId;
                }
                // 点的是系
                if (data.type == 3) {
                    param.departId = data.relId;
                }
                // 点的是年级
                if (data.type == 4) {
                    param.gradeId = data.relId;
                    if(this.$refs.schoolTree.getNode(data.parentId).data.type == 6) {
                        this.formData.schoolNum = this.$refs.schoolTree.getNode(data.parentId).data.relId;
                    }
                }
                // 点的是班级
                if (data.type == 5) {
                    param.classId = data.relId;
                }
                // 点的是校区
                if (data.type == 6) {
                    param.schoolNum = data.relId;
                }
                api.systemConfig.exportUnK12StuList(param).then((res) => {
                    if (res.code == 0) {
                        var key, value;
                        [key, value] = Object.entries(res.data)[0];
                        this.$common.globalExportExl(key, value, '学生导出列表');
                    }

                })
            }

        },
        querySchoolTree () {
            return api.common.querySchoolRelationTree(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.schoolOrganization = res.data;
                        return res.data;
                    } else {
                        this.$message(res.message);
                    }
                })
        },
        querySchoolTreeForClassSelect () {
            return api.common.querySchoolRelationTree(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.schoolOrganizationForClassSelect = [res.data];
                        return [res.data];
                    } else {
                        this.$message(res.message);
                    }
                })
        },
        // 导入
        cancelImportDialog () {
            this.showImport = false;
            this.importFileName = '';
            this.File = null;
            this.importErrorMsg = '';
            this.$refs.importFile.value = '';
        },
        changeExl (file) {
            if (file !== '') {
                var file = this.$refs.importFile.files;
                var formData = new FormData();
                formData.append(this.importObj.key, file[0]);
                this.importFileName = file[0].name;
                this.File = formData;
            }
        },
        openBatchStuImgImport () {
            this.importObj = {
                title: '批量导入照片',
                text: '',
                url: '',
                key: 'studentPicFile',
                api: 'importStudentPic'
            }
            this.showBatchStudentImgImport = true;

        },
        canelzipimgDialog () {
            this.showBatchStudentImgImport = false;
            this.zipFileList = [];
            this.$refs.imgzipupload.$refs.files.value = '';
        },
        // 上传
        acceptFile (fileList) {
            this.FileList = fileList;
        },
        acceptZipFile (fileList) {
            this.zipFileList = fileList;
        },
        uploadZipFile () {
            var formData = new FormData();
            formData.append(this.importObj.key, this.zipFileList[0]);
            this.File = formData;
            this.uploadFile();
        },
        // 导入
        uploadFile () {
            if (!this.File || this.importFileName === '') {
                this.$message('请先选择文件！');
                return;
            }
            this.importErrorMsg = '';
            api.systemConfig[this.importObj.api](this.File).then((res) => {
                if (res.code === 0) {
                    // 导入学生的时候需要轮询
                    // if (this.importObj.key === 'studentFile') {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    const loading = this.$loading({
                        lock: true,
                        text: '正在导入，请稍候...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    let lunxunrequest = () => {

                        return api.common.getImportStatus({ key: key, value: value }).then((res) => {
                            if (res.code == 0 && res.data !== null) {
                                if (res.data.code && res.data.code != 0) {
                                    this.importErrorMsg = res.data.message;
                                    loading.close();
                                } else {
                                    clearTimeout(this.lunxunrequesttimer);
                                    loading.close();
                                    if (this.$refs.importFile) {
                                        this.$refs.importFile.value = '';
                                    }
                                    this.importFileName = '';
                                    this.importErrorMsg = '';
                                    this.File = null;
                                    this.openImportSuccess(res.data.successCount, res.data.failCount, res.data.failFilePath);
                                }

                            } else {
                                this.lunxunrequesttimer = setTimeout(() => {
                                    lunxunrequest();
                                }, 2000)
                            }
                        })
                    }
                    lunxunrequest();

                    // } else {
                    //     if (this.$refs.importFile) {
                    //         this.$refs.importFile.value = '';
                    //     }
                    //     this.importFileName = '';
                    //     this.importErrorMsg = '';
                    //     this.File = null;
                    //     this.openImportSuccess(res.data.successCount, res.data.failCount, res.data.failFilePath);
                    // }

                } else {
                    this.importErrorMsg = res.message;
                }
            })
        },
        downFile (response, name) {
            //创建一个blob对象,file的一种
            let blob = new Blob([response], { type: 'application/x-xls' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            //配置下载的文件名
            link.download = name;
            link.click()
        },
        downErrExl (path) {
            api.common.downloadFailFile(path).then((res) => {
                this.downFile(res, '错误记录文件下载.xls');
            })
        },
        openImportSuccess (s, e, path) {
            this.showImport = false;
            this.showBatchStudentImgImport = false;
            this.showImportSuccess = true;
            this.importObj.stotal = s;
            this.importObj.etotal = e;
            this.importObj.errpath = path;
            // let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
            //                 <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
            //                 <p>导入成功<span class="red">${s}</span>条;失败<span class="red">${e}条</span>!</p>
            //                 <div class="down-tepmlate" style="padding-top:0;">
            //                 <i></i>  <a :href="${url}">点击下载失败名单列表</a>
            //                 </div>
            //             </div>`;


            // this.$alert(html, this.importObj.title,{
            //     dangerouslyUseHTMLString: true,
            //     confirmButtonText: '确定',
            //     showCancelButton: false
            // }).then(()=>{
            // })
        },
        xfStuInfo () {
            let html = `<div style="width:400px;height:128px;padding:20px 50px;text-align: center">
                        <div style=""><span class="el-icon-question" style="color: #FD8C25;font-size: 50px;"></span> </div>
                        <p>确认下发学生信息？</p>
                    </div>`;

            let loading;
            let checkStatus = () => {
                api.systemConfig.checkSendData().then(res => {
                    if (res.code == 0 && res.data) {
                        this.lunxunrequesttimer = null;
                        loading.close();
                        this.openSuccessDialog('下发学生信息', '下发成功');

                    } else {
                        this.lunxunrequesttimer = setTimeout(() => {
                            checkStatus();
                        }, 2000)
                    }
                }).catch(() => {
                    this.lunxunrequesttimer = null;
                    loading.close();
                    this.$message('下发学生信息失败!');
                })
            }

            this.$alert(html, '下发学生信息', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定下发',
                showCancelButton: true
            }).then(() => {
                api.systemConfig.sendData({ schoolId: this.user.schoolId })
                    .then((res) => {
                        if (res.code == 0) {
                            loading = this.$loading({
                                lock: true,
                                text: '正在下发学生信息，请稍候...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            })
                            checkStatus();
                        } else {
                            this.$message('下发学生信息失败!');
                        }
                    })

            })
        },
        synStuInfo () {
            let html = `<div style="width:400px;height:128px;padding:20px 50px;text-align: center">
                        <div style=""><span class="el-icon-question" style="color: #FD8C25;font-size: 50px;"></span> </div>
                        <p>确认更新学生信息？</p>
                    </div>`;

            this.$alert(html, '更新学生信息', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定更新',
                showCancelButton: true
            }).then(() => {
                Promise.all(
                    [api.systemConfig.saveOrUpdateStudent({ schoolId: this.user.schoolId })
                        , api.systemConfig.sendData({ schoolId: this.user.schoolId })])
                    .then((resList) => {
                        let res1 = resList[0];
                        let res2 = resList[1];
                        if (res1.code == 0 && res2.code == 0) {
                            this.openSuccessDialog('更新学生信息', '更新成功');
                        } else {
                            if (res1.code == 0) {
                                this.$message(res2.message);
                            } else if (res2.code == 0) {
                                this.$message(res1.message);
                            } else {
                                this.$message('更新学生信息失败!');
                            }
                        }
                    })
                //    api.systemConfig.saveOrUpdateStudent({
                //     schoolId: this.user.schoolId
                //     }).then((res) => {
                //         if(res.code === 0) {
                //             this.openSuccessDialog('更新学生信息','更新成功');
                //         } else {
                //             this.$message(res.message);
                //         }
                //     })
            })


        }
    },
    created () {

    },
    mounted () {
        this.querySchoolTree().then((data) => {
            this.$nextTick(() => {
                this.currentDeptNode = this.schoolOrganization[0];
                let id = this.schoolOrganization[0].id;
                this.$refs.schoolTree.setCurrentKey(id);
            })
        })
    }
}
</script>
<style lang="scss">
html {
  height: auto;
}

.red {
  color: red;
}

.studentConfig {
  width: 1200px;
  padding: 0 0 20px 0;
  margin: 0;
  overflow: hidden;
  .left {
    width: 300px;
    height: 630px;
    float: left;
    .title {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background-color: #26aef3;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .box {
      height: 590px;
      border: 1px solid #dbdbdb;
      border-top: none;
      overflow: auto;
      padding: 0px 0 0 0;
      .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        background-color: #ecf3fd;
      }
      .tree-box {
        color: #333;
        height: 100%;
        .label-text {
          margin-right: 20%;
          color: #333;
        }
        .icon {
          margin-right: 12px;
          color: #333;
        }
      }
    }
  }
  .right {
    width: 860px;
    margin: 0 20px;
    float: left;
    .operation-panel {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      margin-bottom: 20px;
      background-color: #f0f0f0;
      border: 1px solid #dbdbdb;
      .input {
        width: 300px;
        float: right;
        margin-top: 5px;
        .el-input__inner {
          border: 1px solid #26aef3;
          border-right: none;
          width: 220px;
        }
        .el-input-group__append {
          border: 1px solid #26aef3;
          border-left: none;
          background-color: #26aef3;
          color: #fff;
        }
      }
      .btn {
        display: inline-block;
        margin-right: 24px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        &.add-icon {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            background-image: url('add.png');
          }
        }
        &.delete-icon {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background-image: url('delete.png');
          }
        }
        &.export {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 22px;
            height: 22px;
            background-image: url('export.png');
          }
        }
        &.import:before {
          display: inline-block;
          vertical-align: middle;
          content: '';
          width: 18px;
          height: 18px;
          background-image: url('import.png');
        }
      }
    }
    .operate {
      color: #26aef3;
      text-decoration: underline;
      margin-right: 10px;
      cursor: pointer;
    }
    .studentname {
      color: #26aef3;
      cursor: pointer;
    }
  }
  .info {
    display: flex;
    padding-top: 16px;
    .avatar-wrapper {
      flex-basis: 273px;
      padding: 0 52px 0 27px;
      text-align: center;
      .img {
        width: 196px;
        height: 196px;
        background: url('avatar.png') 0 0 no-repeat;
        margin-bottom: 45px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .upload-file-wrapper {
        .file {
          width: 160px;
          height: 40px;
          text-align: center;
          background-color: #26aef3;
          color: #ffffff;
          & + div {
            padding-top: 20px;
            color: #999;
          }
          input {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    ul.form {
      flex-basis: 435px;
      width: 435px;
      & > li {
        &:nth-child(odd) {
          margin-right: 20px;
        }
        display: inline-block;
        width: 200px;
        margin-bottom: 20px;
        .label {
          line-height: 20px;
          margin: 0;
        }
        .el-form-item {
          margin: 0;
        }
        .el-form-item__error {
          top: 50px;
        }
        .el-form-item__content {
          line-height: 0;
        }
        .el-input__inner {
          width: 200px;
        }
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 200px;
        }
      }
    }
  }
  .stu-detail {
    .edit {
      position: absolute;
      right: 56px;
      top: 12px;
      font-size: 17px;
      color: #fff;
      cursor: pointer;
    }
    .info {
      .img {
        height: 375px;
        margin-bottom: 0;
      }
    }
    .detail {
      & > li {
        display: inline-block;
        vertical-align: top;
        color: #727272;
        height: 75px;
        width: 49%;
        border-bottom: 1px dashed #e4e4e4;
        .label {
          font-weight: bolder;
        }
        .text {
          margin-top: 0;
        }
      }
    }
  }
  .import-dialog {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .rel-import-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      .import-btn {
        position: absolute;
        left: 0;
        width: 140px;
        height: 30px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .down-tepmlate {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('down.png') 0 0 no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }
  .import-student {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .import-btn {
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
    }
  }
  .import-student-pic {
    padding: 23px 30px 37px 30px;
    .input-text {
      width: 495px;
      height: 40px;
      margin-right: 20px;
      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
    .upload-file-wrapper {
      display: inline-block;
      width: 160px;
      height: 40px;
      vertical-align: middle;
      cursor: pointer;
      .file {
        width: 160px;
        height: 40px;
        color: #fff;
        background-color: #26aef3;
        cursor: pointer;
      }
    }

    .img-demand {
      color: #333;
      font-size: 13px;
      .title {
        padding: 20px 0;
      }
      .box {
        .img-box {
          display: inline-block;
          padding-left: 30px;
          margin-right: 10px;
          width: 162px;
          font-size: 12px;
          color: #333;
          text-align: center;
          .img-ex {
            width: 132px;
            height: 193px;
            background: url('pic-demand.png') 0 0 no-repeat;
          }
        }
        .demand-box {
          display: inline-block;
          vertical-align: top;
          padding-left: 101px;
          .line {
            position: relative;
            font-size: 12px;
            color: #ffb324;
            margin-bottom: 54px;
            &:last-child {
              margin-bottom: 0;
            }
            &:before {
              position: absolute;
              content: '';
              width: 79px;
              border-top: 1px dashed #ffb324;
              top: 6px;
              left: -101px;
            }
          }
        }
      }
    }
  }
  .combotree {
    position: absolute;
    left: 0;
    top: 51px;
    z-index: 19920104;
    overflow: auto;
    height: 300px;
    width: 200px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  /**修改默认表格**/
  .el-table .sort-caret.ascending {
    border-bottom-color: #fff;
  }
  .el-table .sort-caret.descending {
    border-top-color: #fff;
  }
  .el-table {
    color: #333;
    .normal {
      color: #000;
    }
    .stayout {
      color: red;
    }
    .late {
      color: #fbaf42;
    }
  }
  .el-table--border {
    border-radius: 5px;
  }
  .el-table td,
  .el-table th {
    height: 40px;
    padding: 0;
  }
  .table-header > th {
    height: 40px;
    padding: 0;
    background-color: #26aef3;
    color: #ffffff;
    font-weight: normal;
  }
  .warning-wrapper {
    margin-bottom: 24px;
  }

  .el-button {
    padding: 6px 15px;
  }

  .el-form-item__label,
  .el-dialog__body {
    color: #333;
  }

  .vl-notify {
    z-index: 2018;
    padding: 0;
  }

  .vl-notify .vl-notify-btns {
    padding: 0 0 10px 0;
    text-align: center;
  }

  .warning {
    color: #e6a23c;
  }

  .err-template {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('down.png') 0 0 no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/systemConfig/studentInfoConfig.vue